import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import { s as T } from "./index-CeQqiMIG.js";
import { H as M } from "./RouteGuard-CX6A77iy.js";
import { EditIcon as P } from "lucide-react";
import { useEffect as L } from "react";
import { B as S } from "./Button-BE9IVkWV.js";
import { T as k, C, H as h } from "./Slot-tFjhrd8V.js";
import { P as H } from "./Pagination-EViy7EHt.js";
import { T as D } from "./Toc-Ck0YQtmd.js";
import { a as I, b as R } from "./hook-CZjW2buS.js";
import { u as A } from "./index-Bm35Tkgf.js";
const _ = {
  h2: ({ children: t, id: s }) => /* @__PURE__ */ e.jsx(h, { level: 2, id: s, registerNavigationAnchor: !0, children: t }),
  h3: ({ children: t, id: s }) => /* @__PURE__ */ e.jsx(h, { level: 3, id: s, registerNavigationAnchor: !0, children: t })
}, Q = ({
  mdxComponent: t,
  frontmatter: s = {},
  defaultOptions: r,
  __filepath: a,
  tableOfContents: n,
  excerpt: u
}) => {
  const v = I()?.categoryLabel, o = s.title, p = s.description ?? u, c = s.category ?? v, w = s.toc === !1 || r?.toc === !1, b = o ?? n.find((i) => i.depth === 1)?.value, N = s.disable_pager ?? s.disablePager ?? r?.disablePager ?? !1, f = s.showLastModified ?? r?.showLastModified ?? !0, d = s.lastModifiedTime ? new Date(s.lastModifiedTime) : null, l = s.suggestEdit !== !1 && (s.suggestEdit ?? r?.suggestEdit), g = l ? l.url.replaceAll("{filePath}", a) : null, y = l ? l.text || "Edit this page" : null, j = n.find((i) => i.depth === 1)?.children ?? // if `title` is provided by frontmatter it does not appear in the table of contents
  n.filter((i) => i.depth === 2), E = !w && j.length > 0, { prev: x, next: m } = R();
  return L(() => {
    if (process.env.NODE_ENV === "development")
      return window.__getReactRefreshIgnoredExports = ({ id: i }) => {
        if (i.endsWith(a))
          return ["frontmatter", "tableOfContents"];
      }, () => {
        window.__getReactRefreshIgnoredExports = void 0;
      };
  }, [a]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "grid grid-cols-1 xl:grid-cols-(--sidecar-grid-cols) gap-8 justify-between",
      "data-pagefind-filter": "section:markdown",
      "data-pagefind-meta": "section:markdown",
      children: [
        /* @__PURE__ */ e.jsxs(M, { children: [
          /* @__PURE__ */ e.jsx("title", { children: b }),
          p && /* @__PURE__ */ e.jsx("meta", { name: "description", content: p })
        ] }),
        /* @__PURE__ */ e.jsxs(k, { className: "max-w-full xl:w-full xl:max-w-3xl flex-1 shrink pt-(--padding-content-top)", children: [
          (c || o) && /* @__PURE__ */ e.jsxs("header", { children: [
            c && /* @__PURE__ */ e.jsx(C, { children: c }),
            o && /* @__PURE__ */ e.jsx(h, { level: 1, id: T(o), children: o })
          ] }),
          /* @__PURE__ */ e.jsx(
            t,
            {
              components: { ...A(), ..._ }
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "h-16" }),
          f && d || g ? /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between text-xs text-muted-foreground ", children: [
            /* @__PURE__ */ e.jsx("div", {}),
            /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e.jsx("div", { children: g && /* @__PURE__ */ e.jsx(S, { asChild: !0, variant: "ghost", size: "sm", children: /* @__PURE__ */ e.jsxs(
                "a",
                {
                  href: g,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "flex items-center gap-1",
                  children: [
                    /* @__PURE__ */ e.jsx(P, { size: 12 }),
                    y
                  ]
                }
              ) }) }),
              /* @__PURE__ */ e.jsx("div", { children: f && d && /* @__PURE__ */ e.jsxs(
                "div",
                {
                  title: d.toLocaleString(void 0, {
                    dateStyle: "full",
                    timeStyle: "medium"
                  }),
                  children: [
                    "Last modified on",
                    " ",
                    /* @__PURE__ */ e.jsx("time", { dateTime: d.toISOString(), children: d.toLocaleDateString(void 0, {
                      dateStyle: "long"
                    }) })
                  ]
                }
              ) })
            ] })
          ] }) : null,
          !N && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("div", { className: "h-px bg-border mt-2 mb-6" }),
            /* @__PURE__ */ e.jsx(
              H,
              {
                prev: x ? { to: x.id, label: x.label } : void 0,
                next: m ? { to: m.id, label: m.label } : void 0,
                className: "mb-10"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "hidden xl:block", "data-pagefind-ignore": "all", children: E && /* @__PURE__ */ e.jsx(D, { entries: j }) })
      ]
    }
  );
};
export {
  Q as MdxPage
};
//# sourceMappingURL=MdxPage-BFKqQsmK.js.map
